import React from 'react';
import { Modifier } from '../../../lib/bemUtils/Modifier';
import Bem from '../../../lib/bemUtils/bem';
import { LoadingSpinner } from './LoadingSpinner';

type LoadingSpinnerContainerProps = {
  modifier?: Modifier<'overlay'>;
};

export function LoadingSpinnerContainer({ modifier }: LoadingSpinnerContainerProps) {
  return (
    <div className={Bem('loading-spinner__outer-container', modifier)}>
      <div className="loading-spinner__inner-container">
        <LoadingSpinner />
      </div>
    </div>
  );
}
